import { createFileRoute } from '@tanstack/react-router';
import ComponentsExample from '../../../pages/examples/ComponentsExample';

export const Route = createFileRoute('/_private/_home/components')({
  component: ComponentsExample,
});
